export const ASCENDING = {
  KIND: "Ascending",
  TABLE: "ascending_state",
  ACTION: "",
};

export const GDA_CONTINUOUS = {
  KIND: "GDAContinuous",
  TABLE: "gda_continuous_state",
  ACTION: "GDAContinuousPurchase",
};

export const GDA_DISCRETE = {
  KIND: "GDADiscrete",
  TABLE: "gda_discrete_state",
  ACTION: "GDADiscretePurchase",
};

export const AUCTIONS = {
  [ASCENDING.KIND]: ASCENDING,
  [GDA_CONTINUOUS.KIND]: GDA_CONTINUOUS,
  [GDA_DISCRETE.KIND]: GDA_DISCRETE,
};
